module.exports = __webpack_public_path__ + "static/media/DSC07450.b168fd0f.JPG";